"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Cube;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cube = require("../helpers/cube");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Cube({
  color,
  background
}) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const canvas = ref.current;

    if (typeof window !== "undefined") {
      canvas.width = canvas.parentNode.clientWidth;
      canvas.height = canvas.parentNode.clientWidth;
      window.addEventListener("resize", resize);
      draw();
      return () => window.removeEventListener("resize", resize);
    } else {
      canvas.width = 1920;
      canvas.height = 1080;
    }

    draw();
  }, []);

  const resize = () => {
    const canvas = ref.current;
    canvas.width = canvas.parentNode.clientWidth;
    canvas.height = canvas.parentNode.clientHeight;
    draw();
  };

  const draw = () => {
    const canvas = ref.current;

    if (canvas.getContext) {
      const context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

      if (context) {
        const programInfo = (0, _cube.info)(context);
        const buffers = (0, _cube.facets)(context, color);
        let then = 0;
        let rotation = 0.0;

        const render = now => {
          now *= 0.001;
          const deltaTime = now - then;
          then = now;
          (0, _cube.prepare)(context, background);
          (0, _cube.apply)(context, programInfo, buffers, rotation);
          rotation += deltaTime;
          requestAnimationFrame(render);
        };

        requestAnimationFrame(render);
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement("canvas", {
    ref: ref
  });
}

Cube.propTypes = {
  color: _propTypes.default.string,
  background: _propTypes.default.string
};
Cube.defaultProps = {
  color: "#ff0000",
  background: "#000000"
};